export const redirectAfterRegistration = (): void => {
  const registerForm = <HTMLElement>document.querySelector('form[action$="/account"][method="post"]');
  if (!registerForm) return;

  const whereToRedirectAfterRegistering = <string>'/account';
  const formElement = <HTMLInputElement>document.createElement('input');
  formElement.setAttribute('type', 'hidden');
  formElement.setAttribute('name', 'return_to');
  formElement.setAttribute('value', whereToRedirectAfterRegistering);

  registerForm.append(formElement); // Add the element to the form.
}
  